import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import backBtnMobile from "../../assets/images/backBtnMobile.svg";
import backBtn from "../../assets/images/backBtn.svg";
import { EducationalPaycheck } from "./EducationalComponents";
import EducationalContentHeader from "./EducationalContentHeader";
import EducationalContentContinueButton from "./EducationalContentContinueButton";
import { GUEST_ENROLLMENT_PATHS, guestEnrollmentBackPath, guestEnrollmentPathFromStep, normalizeGuestStepKey } from "../../common/guestEnrollmentFlow";
import { getItem } from "../../common/localStorage";
import { getPaycheckIllustrationHandler } from "../../redux/action/guestUserAction/getPaycheckIllustration";
import Loader from "../Loder/loader";
import { STATUS_CODE } from "../../common";
import NoDataAvailableState from "./NoDataAvailableState";
import { stepperNextStepHandler, stepperNextStepSliceAction } from "../../redux/action/guestUserAction/stepperNextStep";

const UpdatedPaycheck = () => {
  const stateLocation = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const campaignMemberId = getItem("guestLoginResponse")?.id;
  const paycheckSelector = useSelector((state) => state?.getPaycheckIllustration);
  const getStepperNextStep = useSelector((state) => state?.stepperNextStep);


  const illustration = paycheckSelector?.data?.data;

  const isPaycheckApiSuccess =
    paycheckSelector?.data?.statusCode === STATUS_CODE.OK;
  const showNoDataState =
    !paycheckSelector?.isLoading &&
    !isPaycheckApiSuccess;



  useEffect(() => {
    dispatch(
      getPaycheckIllustrationHandler(
        campaignMemberId ? { campaignMemberId } : {},
      ),
    );
  }, [campaignMemberId, dispatch]);

  const handleBack = () => {
    navigate(guestEnrollmentBackPath("paycheck"));
  };

  const handleContinue = () => {
    dispatch(stepperNextStepHandler({
      currentStep: "PAYCHECK_ILLUSTRATION_UPDATED",
    }));
    // navigate("/guest-user/enrollment");
  };

  useEffect(() => {
    const payload = getStepperNextStep?.data;
    if (payload?.statusCode === STATUS_CODE.OK) {
      const nextStep = payload?.data?.nextStep;
      const nextPath = guestEnrollmentPathFromStep(nextStep);
      const navigateState = {
        guestEducationalBackTo: GUEST_ENROLLMENT_PATHS.welcome,
        ...(normalizeGuestStepKey(nextStep) === "ENROLLMENT_ESIGN_COMPLETED"
          ? { enrollmentDecision: "YES" }
          : { enrollmentDecision: "NO" }),
      };
      navigate(nextPath || GUEST_ENROLLMENT_PATHS.educational, {
        state: navigateState,
      });
      dispatch(stepperNextStepSliceAction.stepperNextStepSliceReset());
    }
  }, [getStepperNextStep, navigate, dispatch]);

  return (
    <>

      <EducationalContentHeader
        backBtnSrc={backBtn}
        backBtnMobileSrc={backBtnMobile}
        onBack={handleBack}
        title={t("Paycheck Illustration")}
        hideNavigation={true}
      >
        <div className="stepperview mb-40">
          {paycheckSelector?.isLoading && (
            <Loader loaderTransform="loaderTransform" />
          )}
          {!paycheckSelector?.isLoading && showNoDataState && (
            <NoDataAvailableState subtitle="There is no educational material found" />
          )}
          {!paycheckSelector?.isLoading && !showNoDataState && (
            <EducationalPaycheck
              illustration={illustration}
              showPaycheckUpdatedCallout={true}
            />
          )}
        </div>

        <EducationalContentContinueButton
          hideNavigation={false}
          onContinue={handleContinue}
          buttonLabel={t("Continue to Enrollment")}
        />
      </EducationalContentHeader>
    </>
  );
};

export default UpdatedPaycheck;
